import React, { MouseEventHandler, useState } from 'react'

import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import MenuItem from '@material-ui/core/MenuItem'
import Menu from '@material-ui/core/Menu'
import Avatar from '@material-ui/core/Avatar'
import Typography from '@material-ui/core/Typography'
import { makeStyles, createStyles } from '@material-ui/core/styles'

import Logo from './Logo'
import { useCredentials, useLogout } from '@dentalux/security/lib'
import LanguageSwitch from './LanguageSwitch/LanguageSwitch'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles((theme) =>
  createStyles({
    logo: {
      marginRight: theme.spacing(1),
    },
    menuBtn: {
      marginLeft: -8,
      marginRight: 20,
    },
    sectionDesktop: {
      display: 'none',
      [theme.breakpoints.up('sm')]: {
        display: 'flex',
      },
    },
    grow: {
      flexGrow: 1,
    },
  })
)

interface Props {
  className?: string
  handleMenuClose: MouseEventHandler
  navItems?: React.ReactNode
}

const NavBar: React.FC<Props> = ({ className, handleMenuClose, navItems }) => {
  const { t } = useTranslation()
  const classes = useStyles()
  const { authentication: user } = useCredentials()
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const logout = useLogout()

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  return (
    <AppBar position="sticky" className={className} elevation={1}>
      <Toolbar>
        <Logo className={classes.logo} />
        <Typography variant="h4" color="primary">
          {t('pages_salary_calculation')}
        </Typography>
        <div className={classes.grow} />
        <div className={classes.sectionDesktop}>{navItems}</div>
        {user && (
          <div>
            <IconButton
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              color="inherit"
            >
              <Avatar alt={user.name} src={user.imgUrl as string} />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={open}
              onClose={handleClose}
            >
              <MenuItem>
                <LanguageSwitch />
              </MenuItem>
              <MenuItem onClick={logout}>{t('btn_sign_out')}</MenuItem>
            </Menu>
          </div>
        )}
      </Toolbar>
    </AppBar>
  )
}

export default NavBar
